import { Text } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

import { useDashboardServicesStore } from '../../../../models/useDashboardServicesModel';
import { useUtcOffsetStore } from '../../../../models/useUtcOffsetModel';
import { ThreatType } from '../../../../utils/enums';
import { getServiceNamesByValues } from '../../../../utils/service';
import { formatTable } from '../../../../utils/table';
import { generateRedirectUrlToLog } from '../../../Log/shared';
import TableTemplate from '../../Charts/TableTemplate';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

export default function TableDataParse(props: {
  data: any;
  type: 'URL' | 'FILE';
  day: string;
  timeFormat: string;
}) {
  const timeModel = useUtcOffsetStore();
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '20%', grow: 1, align: 'left', tooltip: true },
    { width: '15%', grow: 0, align: 'right' },
    { width: '15%', grow: 0, align: 'left', tooltip: true },
    { width: '20%', grow: 1, align: 'left', tooltip: true },
    { width: '20%', grow: 0, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.threat'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.riskLevel'),
    t('dashboard.chart.column.fileNameAliases'),
    t('dashboard.chart.column.lastDetected'),
  ];
  const riskLevelMap = new Map<string, string>([
    ['High Risk', t('dashboard.risk.highRisk')],
    ['Medium Risk', t('dashboard.risk.mediumRisk')],
    ['Low Risk', t('dashboard.risk.lowRisk')],
    ['No Risk', t('dashboard.risk.noRisk')],
    ['UNKNOWN', t('dashboard.risk.unknown')],
  ]);
  const data = formatTable(
    props.data,
    props.type,
    props.day,
    riskLevelMap,
    timeModel.offset,
    props.timeFormat
  );
  if (data && data.length > 0) {
    data.forEach((item: any, index: number) => {
      data[index][1] =
        data[index][1] === 0 ? (
          0
        ) : (
          <RedirectLink
            href={`logs?${generateRedirectUrlToLog(
              [
                {
                  field: 'threatType',
                  values: [
                    ThreatType.MaliciousURL,
                    ThreatType.MaliciousFile,
                    ThreatType.Ransomware,
                  ],
                  type: 'terms',
                },
                {
                  field: 'securityFilterName',
                  values: [SecurityFilterName.VirtualAnalyzer],
                  type: 'terms',
                },
                {
                  field: 'ddaaasRiskLevel',
                  values: [data[index][2]],
                  type: 'terms',
                },
                {
                  field: 'fileSha1',
                  values: [data[index][5] as string],
                  type: 'terms',
                },
                {
                  field: 'scanSource',
                  values: getServiceNamesByValues(
                    servicesModel.enabledServices
                  ),
                  type: 'terms',
                },
              ],
              props.day,
              LogTypeEnum.DETECTION
            )}`}
          >
            <Text>{data[index][1]}</Text>
          </RedirectLink>
        );
      data[index].splice(-1, 1);
    });
  }
  return <TableTemplate config={config} header={header} data={data} />;
}
